import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import trainerRoutes from "../../../pages/trainer/routes";
import coursesService from "../../../services/courses.service";


const TrainerSidenav = () => {
    const location = useLocation()
    const [courseId, setCourseId] = useState('')
    const params = useParams()

    useEffect(() => {
        const course_id : any = params.course_id;
        setCourseId(course_id);
        

        coursesService.getCourse(course_id).then(
            (course)=>{
                localStorage.setItem('courseName', JSON.stringify(course.data.name));
            }
        )
    }, [courseId])
    
    const activeLink = (link: string, keywords: string[]) => {
        const style = {

            borderColor: 'white',
            borderLeft: '',
            bgColor: 'white',
            textColor: '#9E9E9E'
        };

        if (keywords.some(keyword => location.pathname.includes(keyword))) {
            
            style.borderColor = "#EC3337";
            style.borderLeft = '3px Solid';
            style.bgColor = '#FFFAFA';
            style.textColor = ' #EC3337'
        }

        return style;
    };
    return (
        <Box py='40px' bg='white' mr='30px' minHeight='225px' width={{lg:'20%',md:'25%'}} height='fit-content' display={{lg:'block', md:'block', sm:'none', base:'none'}}>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.CourseInformationLink(courseId), ['course-information']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.CourseInformationLink(courseId), ['course-information']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.CourseInformationLink(courseId), ['course-information']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.CourseInformationLink(courseId), ['course-information']).textColor} lineHeight={10} fontWeight='500' >
                <Link to={trainerRoutes.trainerCourses.CourseInformationLink(courseId)}>Course Information</Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.AnnouncementLink(courseId), ['announcement']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.AnnouncementLink(courseId), ['announcement']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.AnnouncementLink(courseId), ['announcement']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.AnnouncementLink(courseId), ['announcement']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.AnnouncementLink(courseId)}>Announcements</Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.TraineesLink(courseId), ['trainees', 'my-attendance-list']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.TraineesLink(courseId), ['trainees', 'my-attendance-list']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.TraineesLink(courseId), ['trainees', 'my-attendance-list']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.TraineesLink(courseId), ['trainees', 'my-attendance-list']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.TraineesLink(courseId)}>My trainees</Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.CalendarLink(courseId), ['calendar']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.CalendarLink(courseId), ['calendar']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.CalendarLink(courseId), ['calendar']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.CalendarLink(courseId), ['calendar']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.CalendarLink(courseId)}> Event Scheduler</Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.DiscussionLink(courseId), ['discussion', 'discussions']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.DiscussionLink(courseId), ['discussion', 'discussions']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.DiscussionLink(courseId), ['discussion', 'discussions']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.DiscussionLink(courseId), ['discussion', 'discussions']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.DiscussionLink(courseId)}> Discussions </Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.AssignmentsLink(courseId), ['assessments', 'assignment']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.AssignmentsLink(courseId), ['assessments', 'assignment']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.AssignmentsLink(courseId), ['assessments', 'assignment']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.AssignmentsLink(courseId), ['assessments', 'assignment']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.AssignmentsLink(courseId)}> Assessments </Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.ResultLink(courseId), ['results', 'result']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.ResultLink(courseId), ['results', 'result']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.ResultLink(courseId), ['results', 'result']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.ResultLink(courseId), ['results', 'result']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.ResultLink(courseId)}> Results </Link>
            </Box>
            <Box pl='40px' mb='20px' pr='30px' borderLeft={activeLink(trainerRoutes.trainerCourses.ResourcesLink(courseId), ['resource', 'resources']).borderLeft}
                borderColor={activeLink(trainerRoutes.trainerCourses.ResourcesLink(courseId), ['resource', 'resources']).borderColor}
                bg={activeLink(trainerRoutes.trainerCourses.ResourcesLink(courseId), ['resource', 'resources']).bgColor}
                color={activeLink(trainerRoutes.trainerCourses.ResourcesLink(courseId), ['resource', 'resources']).textColor} lineHeight={10} fontWeight='500'>
                <Link to={trainerRoutes.trainerCourses.ResourcesLink(courseId)}> Resources </Link>
            </Box>
        </Box>
    )
}

export default TrainerSidenav;